/* ============================================================
   BDP — Rodapé: menus em <details data-bdp-footer>.
   >= 750px: sempre abertos — seta [open], marca a classe
   .bdp-footer__details--static (CSS esconde o caret e corta o
   pointer-events do summary) e tira o summary do tab order.
   < 750px: accordion normal, fechado por padrão.
   Reage à mudança do matchMedia e a shopify:section:load
   (theme editor re-renderiza a section).
   O markup renderiza com [open]: sem JS, desktop e mobile ficam
   com tudo visível (degradação segura).
   ============================================================ */

(function () {
  'use strict';

  var STATIC_CLASS = 'bdp-footer__details--static';
  var mq = window.matchMedia('(min-width: 750px)');

  function apply() {
    var items = document.querySelectorAll('details[data-bdp-footer]');

    for (var i = 0; i < items.length; i++) {
      var details = items[i];
      var summary = details.querySelector('summary');

      if (mq.matches) {
        details.setAttribute('open', '');
        details.classList.add(STATIC_CLASS);
        if (summary) summary.setAttribute('tabindex', '-1');
      } else {
        details.classList.remove(STATIC_CLASS);
        details.removeAttribute('open');
        if (summary) summary.removeAttribute('tabindex');
      }
    }
  }

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', apply);
  } else if (typeof mq.addListener === 'function') {
    /* Safari < 14 */
    mq.addListener(apply);
  }

  document.addEventListener('shopify:section:load', apply);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
